import { CouponButtonType, CouponTagColor } from '@tencent/wphk-act-base-ui';
import { CouponItemConfigItem, CouponItemConfigItemV2 } from './config-type';
import { GoodItem } from '@tencent/wphk-act-base-cgi';

/** coupon状态 */
export enum CouponState {
  enable = '0', // 可领取
  got = '1', // 已领取（用不到）
  used = '2', // 已使用（用不到）
  expired = '3', // 已过期
  over = '4', // 个人超限
  end = '5', // 售罄
  pover = '6', // 平台当日限额
  tover = '7', // 时段限额（用不到）
  unable = '99', // 不可领 印花不足
}

/**
 * 兑换活动参与及奖品（优惠券）信息
 */
export type ExActAndCouponInfo = {
  /* 优惠券批次号  */
  couponId: string;
  /* 优惠券批次号密文 */
  enCouponId: string;
  /* 优惠券状态 */
  couponState: CouponState;
  /* 可领取百分比 */
  availablePercent: string;
  /* 加密兑换活动id */
  enExActId: string;
  /* 兑换需要资格（印花）数量 */
  exQualCnt: number;
  /* 兑换需要资格（印花）批次号 */
  exQualId: string;
  /* 开始时间 */
  exStartTime: Date;
  /** 是否是日限额的券 */
  isDayLimitCoupon: boolean;
  /** 系统时间 */
  exSysTime: Date | undefined;
  // 优化：e-stamp 统一开始兑换时间和结束兑换时间 故删除couponExchStartTime 、 couponExchEndTime
};

/**
 * 兑换活动、配置、优惠券信息
*/
export type ExActAndConfigCouponInfo = ExActAndCouponInfo & CouponItemConfigItem;

/**
 * 券配置 = 兑换活动信息 + 货源券配置 + 后台静态券配置
 */
export type ExActAndConfigCouponInfoV2 = ExActAndCouponInfo & CouponItemConfigItemV2 & GoodItem;

/**
 * 券视图配置
 */
export type ViewCouponConf = {
  // 按钮
  /* 是否展示按钮 */
  isShowButton: boolean;
  /* 按钮文本 */
  couponBtnText: string;
  /* 按钮类型 */
  buttonType: CouponButtonType;
  // 左上角
  /* 优惠券标签文本 */
  couponTagText: string;
  /* 优惠券标签颜色 */
  couponTagColor: CouponTagColor;
  // 右上角
  /* 是否展示邮戳 */
  isShowStamp: boolean;
  /* 邮戳文本 */
  stampText: string;
  // 右下角
  /* 优惠券提示条文本 - 右侧 */
  tipsTextRight: string;
};
